import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import { processRepositoryItem } from ".";
import ConfigOption from "./ConfigOption";
import { MenuTypes } from "@dp/services";
import DPServices from "@dp/services";
import BrandRules from "../../../utils/BrandRules";
import { IMenuItemPropertyVariant } from "../MenuDetailModel";
var ConfigProperty = (_dec = observable.ref, _dec2 = observable.shallow, (_class = /*#__PURE__*/function () {
  function ConfigProperty(rawPropertyBean, parent) {
    _classCallCheck(this, ConfigProperty);

    _initializerDefineProperty(this, "_propertyBean", _descriptor, this);

    _defineProperty(this, "_parent", void 0);

    _initializerDefineProperty(this, "_configOptions", _descriptor2, this);

    _initializerDefineProperty(this, "_isDirty", _descriptor3, this);

    makeObservable(this);
    this._parent = parent;
    this.setRawPropertyBean(rawPropertyBean);
  }

  _createClass(ConfigProperty, [{
    key: "setIsDirty",
    value: function setIsDirty(_isDirty) {
      var isRecursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._isDirty = _isDirty;

      if (isRecursive) {
        var _this$options;

        (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.forEach(function (option) {
          var isSelected = option.selected; // if _configProperties present

          if (option !== null && option !== void 0 && option.options && isSelected) {
            var _option$options;

            option === null || option === void 0 ? void 0 : (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.forEach(function (option) {
              option.setIsDirty(_isDirty, true);
            });
          }
        });
      }
    }
  }, {
    key: "processConfigOptionEntries",
    value: function processConfigOptionEntries() {
      var _this = this;

      runInAction(function () {
        var _this$_propertyBean, _this$_propertyBean$s;

        _this._configOptions = (_this$_propertyBean = _this._propertyBean) === null || _this$_propertyBean === void 0 ? void 0 : (_this$_propertyBean$s = _this$_propertyBean.skuBeans) === null || _this$_propertyBean$s === void 0 ? void 0 : _this$_propertyBean$s.map(function (rawSkuBean) {
          return new ConfigOption(rawSkuBean, _this);
        });
      });
    }
  }, {
    key: "setRawPropertyBean",
    value: function setRawPropertyBean(propertyBean) {
      var _this2 = this;

      runInAction(function () {
        _this2._propertyBean = propertyBean;
      });
      this.processConfigOptionEntries();
    }
  }, {
    key: "clearTree",
    value: function clearTree() {
      var _this$_configOptions;

      var ignoreOptionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      (_this$_configOptions = this._configOptions) === null || _this$_configOptions === void 0 ? void 0 : _this$_configOptions.forEach(function (opt) {
        if (ignoreOptionIds.indexOf(opt.optionId) < 0) {
          opt.clearTree();
        }
      });
    }
  }, {
    key: "makeRecursiveDefaultSelections",
    value: function makeRecursiveDefaultSelections() {
      var _this$_configOptions2;

      var currentSelections = (_this$_configOptions2 = this._configOptions) === null || _this$_configOptions2 === void 0 ? void 0 : _this$_configOptions2.filter(function (opt) {
        return opt.selected;
      });

      if (currentSelections && currentSelections.length === 0) {
        var _this$_configOptions3;

        var onlyOptId = this.isMandatory && ((_this$_configOptions3 = this._configOptions) === null || _this$_configOptions3 === void 0 ? void 0 : _this$_configOptions3.length) === 1 ? this._configOptions[0].optionId : null;
        var defaultOptionId = this.defaultSelectedConfigOption || onlyOptId;

        if (defaultOptionId) {
          var _this$_configOptions4;

          (_this$_configOptions4 = this._configOptions) === null || _this$_configOptions4 === void 0 ? void 0 : _this$_configOptions4.forEach(function (opt) {
            if (opt.optionId === defaultOptionId) {
              opt.makeRecursiveDefaultSelections();
            }
          });
        }
      }
    }
  }, {
    key: "findConfigOptionById",
    value: function findConfigOptionById(optionId) {
      var opt = null;

      this._configOptions.forEach(function (configOpt) {
        if (!opt) {
          if (configOpt.optionId === optionId) {
            opt = configOpt;
          } else {
            opt = configOpt.findConfigOptionById(optionId);
          }
        }
      });

      return opt;
    }
  }, {
    key: "findSelectionTreeForOptionBySelectedId",
    value: function findSelectionTreeForOptionBySelectedId(selectedId) {
      var _this$_configOptions5;

      var nodes = [];
      (_this$_configOptions5 = this._configOptions) === null || _this$_configOptions5 === void 0 ? void 0 : _this$_configOptions5.forEach(function (configOpt) {
        var propNodes = configOpt.findSelectionTreeForOptionBySelectedId(selectedId);

        if (propNodes.length > 0) {
          nodes.push.apply(nodes, _toConsumableArray(propNodes));
        }
      });
      return nodes;
    }
  }, {
    key: "findConfigOptionBySelectedId",
    value: function findConfigOptionBySelectedId(selectedId) {
      var opt = null;

      this._configOptions.forEach(function (configOpt) {
        if (!opt) {
          if (configOpt.selectedId === selectedId) {
            opt = configOpt;
          } else {
            opt = configOpt.findConfigOptionBySelectedId(selectedId);
          }
        }
      });

      return opt;
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this._isDirty;
    }
  }, {
    key: "parentOptionVariant",
    get: function get() {
      var _this$_parent; // TODO: better type check
      // @ts-expect-error type variant doesn't exist on SKU


      return (_this$_parent = this._parent) === null || _this$_parent === void 0 ? void 0 : _this$_parent.variant;
    }
  }, {
    key: "depth",
    get: function get() {
      return this._parent.depth + 1;
    }
  }, {
    key: "variant",
    get: function get() {
      var _this3 = this;

      var conceptCode = DPServices.Config.getConceptCode();
      var isTempSlider = new BrandRules(conceptCode).isTemperatureSlider(this.optionName);
      var showListItemCollapsedByRequired = new BrandRules(conceptCode).showListItemCollapsedByRequired();
      var collapseModifiersIfOptional = new BrandRules(conceptCode).collapseModifiersIfOptional();
      var showImage = new BrandRules(conceptCode).showMenuImages(this);

      if (isTempSlider) {
        return IMenuItemPropertyVariant.TEMPERATURE_CONTROL;
      }

      if (this.depth === 1) {
        if (this.renderingOption === MenuTypes.IRenderingOption.CHECK_BOX) {
          return IMenuItemPropertyVariant.ACCORDION_WITH_CAROUSEL;
        } else {
          return IMenuItemPropertyVariant.ACCORDION_WITH_LIST;
        }
      }

      if (this.depth === 3 && this.floor >= 3) {
        return IMenuItemPropertyVariant.CAROUSEL_WITH_HEADER;
      } // logic for salad selection with required and normal fields
      // showListItemCollapsedByRequired is for the variant
      // collapseModifiersIfOptional is for the property


      if (this.depth === 3 && showListItemCollapsedByRequired) {
        if (this._parent.options.length > 1) {
          var currentIndex = this._parent.options.findIndex(function (option) {
            return option._configOptions === _this3._configOptions;
          });

          if (currentIndex !== -1) {
            if (!this._parent.options[currentIndex].isMandatory && collapseModifiersIfOptional) {
              return IMenuItemPropertyVariant.LIST_ITEM_COLLAPSED_BY_REQUIRED;
            } else {
              return showImage ? IMenuItemPropertyVariant.CAROUSEL_WITH_HEADER : IMenuItemPropertyVariant.SLIDER;
            }
          }
        }
      }

      return IMenuItemPropertyVariant.SLIDER;
    }
  }, {
    key: "floor",
    get: function get() {
      if (this._configOptions && this._configOptions.length > 0) {
        var maxFloor = 0;

        this._configOptions.forEach(function (opt) {
          if (opt.floor > maxFloor) {
            maxFloor = opt.floor;
          }
        });

        return maxFloor + 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._configOptions;
    }
  }, {
    key: "selected",
    get: function get() {
      var _this$_configOptions6;

      var selectedOpts = (_this$_configOptions6 = this._configOptions) === null || _this$_configOptions6 === void 0 ? void 0 : _this$_configOptions6.filter(function (opt) {
        return opt.selected;
      });
      return selectedOpts && selectedOpts.length > 0 ? true : false;
    }
  }, {
    key: "isInValid",
    get: function get() {
      if (this.isMandatory) {
        return this._parent.selected && !this.selected && this.isDirty ? true : false;
      } else {
        return false;
      }
    }
  }, {
    key: "isAlcohol",
    get: function get() {
      var _this$_configOptions7;

      var alcoholOpts = (_this$_configOptions7 = this._configOptions) === null || _this$_configOptions7 === void 0 ? void 0 : _this$_configOptions7.filter(function (opt) {
        return opt.isAlcohol;
      });
      return alcoholOpts ? alcoholOpts.length > 0 : false;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this._configOptions ? this._configOptions.length <= 0 : true;
    }
  }, {
    key: "pretty",
    get: function get() {
      var _this$_configOptions8;

      return {
        isInValid: this.isInValid,
        optionId: this.optionId,
        selected: this.selected,
        optionName: this.optionName,
        renderingOption: this.renderingOption,
        isMultiSelect: this.isMultiSelect,
        isMandatory: this.isMandatory,
        isCollapsible: this.isCollapsible,
        defaultSelectedConfigOption: this.defaultSelectedConfigOption,
        displayName: this.displayName,
        price: this.price,
        selectedId: this.selectedId,
        description: this.description,
        depth: this.depth,
        floor: this.floor,
        variant: this.variant,
        options: (_this$_configOptions8 = this._configOptions) === null || _this$_configOptions8 === void 0 ? void 0 : _this$_configOptions8.map(function (prop) {
          return prop.pretty;
        })
      };
    }
  }, {
    key: "repoItem",
    get: function get() {
      var _this$_propertyBean2;

      return processRepositoryItem((_this$_propertyBean2 = this._propertyBean) === null || _this$_propertyBean2 === void 0 ? void 0 : _this$_propertyBean2.repositoryItem);
    }
  }, {
    key: "optionId",
    get: function get() {
      return this._propertyBean.id;
    }
  }, {
    key: "optionName",
    get: function get() {
      return this.repoItem.defaultDisplayName;
    }
  }, {
    key: "heading",
    get: function get() {
      return this.repoItem.heading;
    }
  }, {
    key: "renderingOption",
    get: function get() {
      return this.repoItem.renderingOption;
    }
  }, {
    key: "isMultiSelect",
    get: function get() {
      return this.repoItem.isMultiSelect;
    }
  }, {
    key: "isMandatory",
    get: function get() {
      return this.repoItem.isMandatory;
    }
  }, {
    key: "isCollapsible",
    get: function get() {
      return this.repoItem.isCollapsible;
    }
  }, {
    key: "defaultSelectedConfigOption",
    get: function get() {
      return this.repoItem.defaultSelectedConfigOption;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this.repoItem.defaultDisplayName;
    }
  }, {
    key: "price",
    get: function get() {
      return this.repoItem.price || this.repoItem.listPrice;
    }
  }, {
    key: "description",
    get: function get() {
      return this.repoItem.description;
    }
  }, {
    key: "selectedId",
    get: function get() {
      var _this$_propertyBean3;

      return (_this$_propertyBean3 = this._propertyBean) === null || _this$_propertyBean3 === void 0 ? void 0 : _this$_propertyBean3.selectedId;
    }
  }, {
    key: "isComboImage",
    get: function get() {
      return this.repoItem.isComboImage;
    }
  }, {
    key: "isDynamicImage",
    get: function get() {
      return this.repoItem.isDynamicImage;
    }
  }, {
    key: "imageUrl",
    get: function get() {
      var _this$_propertyBean4;

      return (_this$_propertyBean4 = this._propertyBean) === null || _this$_propertyBean4 === void 0 ? void 0 : _this$_propertyBean4.imageUrl;
    }
  }, {
    key: "legalDisclaimer",
    get: function get() {
      var _this$_propertyBean5;

      return (_this$_propertyBean5 = this._propertyBean) === null || _this$_propertyBean5 === void 0 ? void 0 : _this$_propertyBean5.legalDisclaimer;
    }
  }, {
    key: "unitOfMeasure",
    get: function get() {
      return this.repoItem.uom;
    }
  }, {
    key: "winePairingIds",
    get: function get() {
      return this.repoItem.winePairingIds;
    }
  }, {
    key: "preparationTime",
    get: function get() {
      return this.repoItem.preparationTime;
    }
  }, {
    key: "maxCookTime",
    get: function get() {
      return this.repoItem.maxCookTime;
    }
  }, {
    key: "adminDisplayName",
    get: function get() {
      var _this$repoItem;

      return (_this$repoItem = this.repoItem) === null || _this$repoItem === void 0 ? void 0 : _this$repoItem.adminDisplayName;
    }
  }, {
    key: "selectedIds",
    get: function get() {
      return this.selectedConfigOptions.map(function (opt) {
        return opt.selectedId;
      });
    }
  }, {
    key: "selectedConfigOptions",
    get: function get() {
      var _this$_configOptions9;

      var opts = [];
      (_this$_configOptions9 = this._configOptions) === null || _this$_configOptions9 === void 0 ? void 0 : _this$_configOptions9.forEach(function (configOption) {
        opts = opts.concat(configOption.selectedConfigOptions);
      });
      return opts;
    }
  }, {
    key: "selectedConfigOptionsPrice",
    get: function get() {
      return this.selectedConfigOptions.reduce(function (total, configOpt) {
        return configOpt.price && configOpt.price > 0 ? total + configOpt.price : total;
      }, 0);
    }
  }]);

  return ConfigProperty;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_propertyBean", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_configOptions", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_isDirty", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setIsDirty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDirty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parentOptionVariant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parentOptionVariant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "depth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "depth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "variant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "variant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "floor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "floor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "options", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAlcohol", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAlcohol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmpty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pretty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pretty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeRecursiveDefaultSelections", [action], Object.getOwnPropertyDescriptor(_class.prototype, "makeRecursiveDefaultSelections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "repoItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "repoItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "heading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "heading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderingOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "renderingOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMultiSelect", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMandatory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMandatory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCollapsible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCollapsible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultSelectedConfigOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultSelectedConfigOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "price", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "price"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isComboImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComboImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDynamicImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDynamicImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "legalDisclaimer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legalDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitOfMeasure", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unitOfMeasure"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "winePairingIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "winePairingIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preparationTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preparationTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxCookTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxCookTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adminDisplayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "adminDisplayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedConfigOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedConfigOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedConfigOptionsPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedConfigOptionsPrice"), _class.prototype)), _class));
export { ConfigProperty as default };